namespace Gordic.Vyp.Lists {
    @Decorators.gcontent
    export class VypListBasePage extends GContentBase<Wfl.ListAC.WflZasilkyListBaseAC>
    {
        ZpusobDorProp: Wfl.Interface.WflczpdEnum;
        ListParams: Vyp.WebControls.GVypListParamsDto;
        Predplneni: Wfl.Interface.GPredplneniZasilekDto;
        VypraveniSettings: Wfl.Interface.GVypraveniSettingsDto;
        PredplneniValidotors: any;
        DataMatrixDto: Wfl.Interface.GDataMatrixDto;
        PosledniPodaciCislo: JsonDecimal;
        _$fileField: JQuery;

        public static CreateActionsTisk(content: GContentType<VypListBasePage>): void {
            content.printActionsSubmenu.push(this.CreateActionTiskPodacihoArchu(content, Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu.tisknout));
            content.printActionsSubmenu.push(this.CreateActionTiskPodacihoArchu(content, Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu.tisknoutDoporucene));
            content.printActionsSubmenu.push(this.CreateActionTiskPodacihoArchu(content, Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu.tisknoutDoZahranici));
            content.printActionsSubmenu.push(this.CreateActionTiskPodacihoArchu(content, Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu.tisknoutDoZahraniciDoporucene));
            content.printActionsSubmenu.push(this.CreateActionTiskEvidListPostovneho(content));
        }

        public static CreateActionsPredplneni(content: GContentType<VypListBasePage>): void {
            if (content.submenuActions == undefined) content.submenuActions = [];
            content.submenuActions.push(this.CreateActionPredplnit(content, Wfl.Interface.TypPredplneniEnum.PodaciCislo));
            content.submenuActions.push(this.CreateActionPredplnit(content, Wfl.Interface.TypPredplneniEnum.Vaha));
            content.submenuActions.push(this.CreateActionPredplnit(content, Wfl.Interface.TypPredplneniEnum.Poplatek));
            content.submenuActions.push(this.CreateActionPredplnit(content, Wfl.Interface.TypPredplneniEnum.Vse));
            content.submenuActions.push(this.CreateActionPredplnitPoplatekDlePrednastaveni(content));
            content.submenuActions.push(this.CreateActionPredplnitDlePrednastaveni(content));
            content.submenuActions.push(this.CreateActionUlozitPredplneni(content));
            Gordic.Wfl.AC.WflBaseAC.AddSubMenu(content, "jres:23900047", Gordic.Gin.Icons.ActionEnum.editovat); //RC 23900047 : Předplnit
        }

        public static CreateGridZasilekVyp(content: GContentType<VypListBasePage>) {
            var gf = Gordic.Wfl.ListAC.WflListBaseAC.GetGridFormat();
            gf.addIconColumn(Gordic.Gin.Globals.GridIconOptResulInfo());
            gf.addIconColumn(Gordic.Wfl.ListAC.DelegateTypZasilkyIcon());
            gf.addIconColumn(Gordic.Wfl.ListAC.DelegateSablonaZasilkyIcon());
            if (content.model.TypSeznamu == Wfl.Interface.TypSeznamuZasilek.vypraveni) {
                switch (content.ZpusobDorProp) {
                    case Wfl.Interface.WflczpdEnum.EMail:
                        gf.addIconColumn(Gordic.Wfl.ListAC.DelegateSSignIcon());
                        break;
                }
            }
            if (content.SessionInfo.IsVyvoj) {
                gf.addTextColumn(Wfl.ListPrefabs.SXSColumn());
                gf.addNumberColumn(Wfl.ListPrefabs.tridVypColumn());
                gf.addNumberColumn(Wfl.ListPrefabs.KVColumn());
            }
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.adresatColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.zastOsobaNazevColumn());
            //gf.add(Gordic.Wfl.ListPrefabs.vecColumn());

            switch (content.ZpusobDorProp) {
                case Wfl.Interface.WflczpdEnum.Posta:
                case Wfl.Interface.WflczpdEnum.DorucovaciSluzba:
                case Wfl.Interface.WflczpdEnum.Kuryr:
                    gf.add(Wfl.ListPrefabs.podaciCisloColumn());
                    gf.addDecimalColumn(VypPrefabs.poplatekColumn());
                    gf.addDecimalColumn(VypPrefabs.vahaColumn());
                    gf.addDecimalColumn(VypPrefabs.cenaColumn());
                    break;
            }

            gf.addTextColumn(Gordic.Wfl.ListPrefabs.postSluzbColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.druhZasilkyColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.idDorucenky());
            if (content.model.TypSeznamu == Wfl.Interface.TypSeznamuZasilek.vypraveni) {
                gf.addTextColumn(Gordic.Wfl.ListPrefabs.odesilajiciAktStartSUColumn());
            }
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.cisloJednaciColumn(content.LabelCisloJednaci));
            gf.add(Gordic.Wfl.ListPrefabs.odesilajiciAktStartColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.ixpColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.zpusobDoruceniColumn());

            if (content.model.TypSeznamu == Wfl.Interface.TypSeznamuZasilek.vypraveni) {
                switch (content.ZpusobDorProp) {
                    case Wfl.Interface.WflczpdEnum.DatovaSchranka:
                    case Wfl.Interface.WflczpdEnum.GEX:
                        gf.addTextColumn(VypPrefabs.idDSOdesiltele());
                        break;
                }
                gf.addDateTimeColumn(Gordic.Wfl.ListPrefabs.datOdesColumn());

                gf.add(Gordic.Wfl.ListPrefabs.adresatJmenoColumn());
                switch (content.ZpusobDorProp) {
                    case Wfl.Interface.WflczpdEnum.Posta:
                    case Wfl.Interface.WflczpdEnum.DorucovaciSluzba:
                    case Wfl.Interface.WflczpdEnum.Kuryr:
                        gf.addTextColumn(Gordic.Wfl.ListPrefabs.adresatPostaColumn());
                        gf.addTextColumn(Gordic.Wfl.ListPrefabs.adresatAdresaColumn());
                        break;
                }
            }

            if (content.model.TypSeznamu == Wfl.Interface.TypSeznamuZasilek.kPrevzetiDleID) {
                gf.addTextColumn(Gordic.Wfl.ListPrefabs.nazevStartSUColumn());
                gf.addDateColumn(Gordic.Wfl.ListPrefabs.datOdesColumn());
                gf.addTextColumn(Gordic.Wfl.ListPrefabs.adresatJmenoColumn());
                gf.addTextColumn(Gordic.Wfl.ListPrefabs.adresatPostaColumn());
                gf.addTextColumn(Gordic.Wfl.ListPrefabs.adresatAdresaColumn());
                gf.addDateColumn(Gordic.Wfl.ListPrefabs.datDatZmenaColumn());
            }

            if (content.model.TypSeznamu == Wfl.Interface.TypSeznamuZasilek.vypraveni) {
                switch (content.ZpusobDorProp)
                {
                    case Wfl.Interface.WflczpdEnum.EMail:
                    case Wfl.Interface.WflczpdEnum.DatovaSchranka:
                    case Wfl.Interface.WflczpdEnum.GEX:
                        gf.addNumberColumn({ name: "pocet_el_souboru", caption: "jres:23900020", width: 80 }) //RC 23900020 : Počet el. příloh
                        break;
                }
                switch (content.ZpusobDorProp) {
                    case Wfl.Interface.WflczpdEnum.EMail:
                        gf.addTextColumn(Wfl.ListPrefabs.odesilatelSchrankaColumn());
                        gf.addTextColumn(Wfl.ListPrefabs.adresatSchrankaColumn());
                        break;
                    case Wfl.Interface.WflczpdEnum.DatovaSchranka:
                        if (content.PovolenoHKP) gf.addTextColumn(Wfl.ListPrefabs.adresatHKPcolumn());
                        break;
                }
            }

            gf.addTextColumn(Gordic.Wfl.ListPrefabs.errorTextColumn());
            content.gridFormat = gf;
            Gordic.Wfl.ListAC.WflZasilkyListBaseAC.CreateGridBaseZasilek(content);
        }

        public static GetSelectedGDataZasilkyProVypocetVahyAPoplatkuDto(content: GContentType<VypListBasePage>): Wfl.Interface.GDataZasilkyProVypocetVahyAPoplatkuDto[] {
            return content.mainGrid.ggrid<Wfl.Interface.GDataZasilkyProVypocetVahyAPoplatkuDto>("getSelection").map((o) => { return { sxs: o.sxs, poplatek: o.poplatek, vaha: o.vaha, stat: o.stat, druh_zas: o.druh_zas, komb_sluzeb: o.komb_sluzeb, priz_doruc: o.priz_doruc }; }) as Wfl.Interface.GDataZasilkyProVypocetVahyAPoplatkuDto[];
        }

        public static GetAllZasilkaIdSXSDto(content: GContentType<VypListBasePage>): Wfl.Interface.GZasilkaIdSXSDto[] {
            return content.mainGrid.ggrid<Wfl.Interface.GZasilkaIdSXSDto>("getSelection").map((o) => { return { sxs: o.sxs, id_dorunky: o.id_dorucenky }; }) as Wfl.Interface.GZasilkaIdSXSDto[];
        }

        public static CreateActionPredplnit(content: GContentType<VypListBasePage>, typ: Wfl.Interface.TypPredplneniEnum, favorite?: boolean): GAction {

            var l_caption = "jres:23900047" + " "; //RC 23900047 : Předplnit
            switch (typ) {
                case Wfl.Interface.TypPredplneniEnum.PodaciCislo: l_caption += "jres:23900048"; //RC 23900048 : podací číslo
                    break
                case Wfl.Interface.TypPredplneniEnum.Vaha: l_caption += "jres:23900049"; //RC 23900049 : váhu
                    break
                case Wfl.Interface.TypPredplneniEnum.Poplatek: l_caption += "jres:23900050"; //RC 23900050 : poplatek
                    break
                case Wfl.Interface.TypPredplneniEnum.Vse: l_caption += "jres:23900052"; //RC 23900052 : vše
                    break
            }

            var action = new GAction({
                name: "actPredplnit_" + typ,
                icon: Gordic.Gin.Icons.ActionEnum.editovat,
                caption: l_caption,
                tooltip: l_caption,
                run: function (ev, ctx) {
                    content.findFields().gfield("model", "collect", content.Predplneni);
                    if (content.Predplneni) {
                        // predplneni na client
                        var l_ifPodCislo = false;
                        var l_ifVaha = false;
                        var l_ifPoplatek = false;
                        let predplneniServer = false;

                        switch (typ) {
                            case Wfl.Interface.TypPredplneniEnum.PodaciCislo:
                                l_ifPodCislo = true;
                                predplneniServer = true;
                                break
                            case Wfl.Interface.TypPredplneniEnum.Vaha:
                                l_ifVaha = true;
                                break
                            case Wfl.Interface.TypPredplneniEnum.Poplatek:
                                l_ifPoplatek = true;
                                break
                            case Wfl.Interface.TypPredplneniEnum.Vse:
                                predplneniServer = true;
                                l_ifPodCislo = true;
                                l_ifVaha = true;
                                l_ifPoplatek = true;
                                break
                        }

                        Gordic.Vyp.AppSettings.SetVypraveniSettings(content, { novePodaciCislo: content.Predplneni.novePodaciCislo });

                        if (predplneniServer) {
                            var l_selected = Wfl.ListAC.WflZasilkyListBaseAC.GetSelectedGZasilkaEditListDto(content);
                            if (l_selected.length > 0) {
                                content.call<Gordic.Wfl.Interface.GZasilkaEditListDto[]>("PredplnitZasilky", { Selected: l_selected, Typ: typ, Predplneni: content.Predplneni })
                                    .done(function (data) {                                      
                                        if (!content.Info) {
                                            //posledni podaci cislo
                                            content.Predplneni.pod_cislo = content.PosledniPodaciCislo;
                                            content.findFields("pod_cislo").gfield("setValue", content.PosledniPodaciCislo);
                                            Gordic.Vyp.AppSettings.SetVypraveniSettings(content, { posledniPodaciCislo: content.PosledniPodaciCislo });
                                        }

                                        var l_view = content.mainGrid.ggrid<Gordic.Wfl.Interface.GZasilkaEditListDto>("getView");
                                        var l_dataRows = l_view.getDataRows(true);
                                        for (var i = 0; i < data.length; i++) {
                                            var find = l_dataRows.filter((it) => it.data.sxs && it.key === data[i].sxs);
                                            var l_row = find.length === 1 ? find[0] : null;
                                            if (l_row) {
                                                if (l_ifPodCislo) l_row.data.pod_cislo = data[i].pod_cislo;
                                                if (l_ifVaha) l_row.data.vaha = data[i].vaha;
                                                if (l_ifPoplatek) l_row.data.poplatek = data[i].poplatek;
                                            }
                                        }
                                        l_view.updateData(l_dataRows, "reset");
                                    })
                                    .always(function () {
                                        content.endOperation();
                                    });
                            } else Wfl.ListAC.WflListBaseAC.ShowInfoNeniVybranZadnyRadek(content);
                        }
                        else {
                            var l_view = content.mainGrid.ggrid("getView");
                            var l_dataRows = l_view.getDataRows(true);

                            for (var i = 0; i < l_dataRows.length; i++) {
                                if (l_dataRows[i].checked) {
                                    if (l_ifPodCislo) {
                                        var l_podCislo = "";
                                        if (content.Predplneni.text_pred) l_podCislo += content.Predplneni.text_pred;
                                        if (content.Predplneni.pod_cislo) l_podCislo += content.Predplneni.pod_cislo;
                                        if (content.Predplneni.text_za) l_podCislo += content.Predplneni.text_za;
                                        l_dataRows[i].data["pod_cislo"] = l_podCislo;
                                    }

                                    if (l_ifVaha) l_dataRows[i].data["vaha"] = content.Predplneni.vaha;

                                    if (l_ifPoplatek) l_dataRows[i].data["poplatek"] = content.Predplneni.poplatek;
                                }
                            }
                            l_view.updateData(l_dataRows, "reset");
                            content.call<boolean>("UlozPredplneni", { model: content.Predplneni })
                                .done(function (data) { });
                        }
                    }
                }
            });
            if (favorite && favorite == true) action.update({ groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite });
            return action;
        }

        public static CreateActionPredplnitDlePrednastaveni(content: GContentType<VypListBasePage>, favorite?: boolean): GAction {

            var action = new GAction({
                name: "actPredplnitVahuPoplatekDlePrednastaveni",
                icon: Gordic.Gin.Icons.ActionEnum.editovat,
                caption: "jres:23900061", //RC 23900061 : Předplnit poplatek/váhu dle přednastavení
                tooltip: "jres:23900061",
                run: function (ev, ctx) {
                    VypListBasePage.PredplnitPoplatekDlePrednastaveni(content, false)
                }
            });
            if (favorite && favorite == true) action.update({ groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite });
            return action;
        }

        public static CreateActionPredplnitPoplatekDlePrednastaveni(content: GContentType<VypListBasePage>, favorite?: boolean): GAction {

            var action = new GAction({
                name: "actPredplnitVahuPoplatekDlePrednastaveni",
                icon: Gordic.Gin.Icons.ActionEnum.editovat,
                caption: "jres:23900200", //RC 23900200 : Předplnit poplatek dle přednastavení
                tooltip: "jres:23900200",
                run: function (ev, ctx) {
                    VypListBasePage.PredplnitPoplatekDlePrednastaveni(content, true)
                }
            });
            if (favorite && favorite == true) action.update({ groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite });
            return action;
        }

        public static PredplnitPoplatekDlePrednastaveni(content: GContentType<VypListBasePage>, _pouzePoplatek: boolean): void
        {
            var l_selected = VypListBasePage.GetSelectedGDataZasilkyProVypocetVahyAPoplatkuDto(content);
            if (l_selected.length > 0) {
                content.call<Gordic.Wfl.Interface.GDataZasilkyProVypocetVahyAPoplatkuDto[]>("PredplnitPoplatekAVahuDlePrednastaveni", { Selected: l_selected, PouzePoplatek: _pouzePoplatek })
                    .done(function (data) {
                        var l_view = content.mainGrid.ggrid<Gordic.Wfl.Interface.GDataZasilkyProVypocetVahyAPoplatkuDto>("getView");
                        var l_dataRows = l_view.getDataRows(true);
                        for (var i = 0; i < data.length; i++) {
                            var find = l_dataRows.filter((it) => it.data.sxs && it.key === data[i].sxs);
                            var l_row = find.length === 1 ? find[0] : null;
                            if (l_row) {
                                l_row.data.vaha = data[i].vaha;
                                l_row.data.poplatek = data[i].poplatek;
                            }
                        }
                        l_view.updateData(l_dataRows, "reset");
                    })
                    .always(function () {
                        content.endOperation();
                    });
            } else Wfl.ListAC.WflListBaseAC.ShowInfoNeniVybranZadnyRadek(content);
        }

        public static CreateActionEditaceDatPredplneni(content: GContentType<VypListBasePage>, favorite?: boolean): GAction {
            var action = new GAction({
                name: "actEditaceDatPredplneni",
                icon: Gordic.Gin.Icons.ActionEnum.editovat,
                caption: "jres:23900178", //RC 23900178 : Nastaveni hodnot přeplnění
                tooltip: "jres:23900178",
                run: function (ev, ctx) {
                    var rowData = Wfl.ListAC.WflListBaseAC.GetActiveRow(content) as Wfl.Interface.GEditaceZasilkyDto;
                    if (rowData) {
                        Gordic.Vyp.Dialogs.PredplneniZasilkyDlg(content, { data: content.Predplneni }, Gordic.Global.Enums.ModOtevreni.showModalWindow)
                            .done(function (retVal) {
                                if (retVal != null) {
                                    content.Predplneni = retVal;
                                }
                            });
                    }
                }
            });
            if (favorite && favorite == true) action.update({ groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite });
            return action;
        }

        public static CreateActionZmenaHodnot(content: GContentType<VypListBasePage>, favorite?: boolean): GAction {
            var action = new GAction({
                name: "actZmenaHodnot",
                icon: Gordic.Gin.Icons.ActionEnum.editovat,
                caption: "jres:23900062", //RC 23900062 : Změnit hodnoty řádku
                tooltip: "jres:23900062",
                run: function (ev, ctx) {

                    var rowData = Wfl.ListAC.WflListBaseAC.GetActiveRow(content) as Wfl.Interface.GEditaceZasilkyDto;
                    if (rowData) {
                        Gordic.Vyp.Dialogs.EditaceZasilkyDlg(content, { data: rowData }, Gordic.Global.Enums.ModOtevreni.showModalWindow)
                            .done(function (retVal) {
                                if (retVal != null) {
                                    rowData.pod_cislo = retVal.pod_cislo;
                                    rowData.cena = retVal.cena;
                                    rowData.poplatek = retVal.poplatek;
                                    rowData.vaha = retVal.vaha;
                                    Wfl.ListAC.WflListBaseAC.UpdateRowData(content, rowData);
                                    content.NeulozenaData = true;
                                }
                            });
                    }
                }
            });
            if (favorite && favorite == true) action.update({ groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite });
            return action;
        }

        public static CreateFrankovaniActions(content: GContentType<VypListBasePage>): void {
            let l_settings = content.VypraveniSettings;
            if (l_settings && l_settings.typ_frankovani) {
                switch (l_settings.typ_frankovani) {
                    case Wfl.Interface.TypFrankovacihoStroje.NeopostDataMatrixCtecka:
                        if (content.model.TypSeznamu != Gordic.Wfl.Interface.TypSeznamuZasilek.kPrevzetiDleID) {
                            if (content.VypraveniSettings.TypFrankovaniDbParam == Wfl.Interface.TypFrankovaniDbParam.datamatrixCtecka)
                            {                              
                                if (content.Info) Gordic.Wfl.AC.WflBaseAC.ShowFlashWarning(content, content.Info);
                                content.specialActions.push(VypListBasePage.CreateActionFrankovaniOnLine(content, l_settings.typ_frankovani));
                            }
                        }
                        break;

                    case Wfl.Interface.TypFrankovacihoStroje.FramaSoubor:
                        content.specialActions.push(VypListBasePage.CreateActionFrankovaniOffLine(content, l_settings.typ_frankovani));
                        VypListBasePage.CreateGetFileField(content);
                        break;
                }
            }
        }

        public static CreateActionUlozitPredplneni(content: GContentType<VypListBasePage>, favorite?: boolean): GAction {
            var action = new GAction({
                name: "actUlozitPredplneni",
                icon: Gordic.Gin.Icons.ActionEnum.ulozit,
                caption: "jres:23900051", //RC 23900051 : Uložit předplnění
                tooltip: "jres:23900051",
                run: function (ev, ctx) {
                    content.findFields().gfield("model", "collect", content.Predplneni);
                    Gordic.Vyp.AppSettings.SetVypraveniSettings(content,
                        {
                            text_pred: content.Predplneni.text_pred,
                            posledniPodaciCislo: content.Predplneni.pod_cislo,
                            text_za: content.Predplneni.text_za,
                            poplatek: content.Predplneni.poplatek,
                            vaha: content.Predplneni.vaha,
                            novePodaciCislo: content.Predplneni.novePodaciCislo
                            //psc: undefined,
                            //stat: content.Predpln,
                            //dor_sluzba: undefined,
                        })
                }
            });
            if (favorite && favorite == true) action.update({ groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite });
            return action;
        }

        public static CreateActionTiskPodacihoArchu(content: GContentType<VypListBasePage>, typ: Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu): GAction {
            var l_caption = "jres:23900039";
            switch (typ) {
                case Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu.tisknout:
                    break;
                case Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu.tisknoutDoporucene:
                    l_caption += " " + "(" + "jres:23900040" + ")"; //RC 23900040 : doporučené
                    break;
                case Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu.tisknoutDoZahranici:
                    l_caption += " " + "jres:23900168"; //RC 23900168 : do zahraničí
                    break;
                case Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu.tisknoutDoZahraniciDoporucene:
                    l_caption += " " + "jres:23900170" + " " + "(" + "jres:23900040" + ")"; //RC 23900170 : do zahr.
                    break;
            }
            var action = new GAction({
                name: Gordic.Vyp.Globals.Enums.ActionsName.TiskPodacihoArchu,
                icon: Gordic.Gin.Icons.ActionEnum.tisk,
                caption: l_caption, //RC 23900039 : Tisk - Podací arch                
                tooltip: l_caption,
                run: function (ev, ctx) {
                    VypListBasePage.TiskPodacihoArchuPriprava(content, typ);
                }
            });
            return action;
        }

        public static TiskPodacihoArchuPriprava(content: GContentType<VypListBasePage>, typ: Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu) {

            if (content.ListParams.VyberTiskPA == 1) {
                var l_asSelectedSxs = Wfl.ListAC.WflZasilkyListBaseAC.GetSxsArrayFromSelection(content);

                if (l_asSelectedSxs.length > 0) {
                    //oznaceni v temp
                    content.call("UpdateVyberRadku", { Selected: l_asSelectedSxs })
                        .done(function () {
                            VypListBasePage.TiskPodacihoArchu(content, typ);
                        })
                } else content.showFlash("jres:23900183", Gordic.Gin.Globals.Enums.StateEnum.error, content.FlashPanelTimer);  //RC 23900183 : Není vybrán žádný řádek k tisku.
            }
            else {
                VypListBasePage.TiskPodacihoArchu(content, typ);
            }
        }


        public static TiskPodacihoArchu(content: GContentType<VypListBasePage>, typ: Gordic.Vyp.Globals.Enums.TypTiskuPodacihoArchu) {
            var l_ptm = "vyp_ptm_pdarch";
            var act = GAction.createPrintAction({
                name: "dlgTisk",
                caption: "jres:23900163", //RC 23900163 : Generovani s dialogem
                tooltip: "jres:23900163",
                tema: l_ptm,
                reportStarting: function (rep) {
                    let l_settings = content.VypraveniSettings;
                    rep.params.X0000 = content.SessionInfo.LogPorCislo!.toString();
                    rep.params.X0001 = typ.toString();
                    rep.params.X0002 = content.ZpusobDorProp.toString();
                    rep.params.X0003 = content.LabelZnacka;
                    rep.params.X0004 = content.ListParams.VyberTiskPA!.toString();
                    rep.params.X0005 = content.ListParams.IxsIsu ? content.ListParams.IxsIsu : "";
                    rep.params.X0006 = content.ListParams.epa_server_jmeno_souboru ? content.ListParams.epa_server_jmeno_souboru : "";
                    let l_sIDpodavatele = "";
                    if (l_settings.epa_identifikace_podavatele) l_sIDpodavatele = l_settings.epa_identifikace_podavatele.trim();                    
                    if (l_settings.cislo_zakaznicke_karty_odesilatele) l_sIDpodavatele += "#" + l_settings.cislo_zakaznicke_karty_odesilatele.trim();                    
                    if (l_settings.epa_data_odesilatele) l_sIDpodavatele += "|" + l_settings.epa_data_odesilatele.trim();
                    rep.params.X0007 = l_sIDpodavatele;
                    rep.params.X0008 = l_settings.epa_jednoznacne_jmeno ? "2" : "1";
                }
            });
            act.run();
        }

        public static CreateActionTiskKnihyVypravenePosty(content: GContentType<Wfl.ListAC.WflZasilkyListBaseAC>): GAction {
            var action = new GAction({
                name: Gordic.Vyp.Globals.Enums.ActionsName.TiskKnihyVypravenePosty,
                icon: Gordic.Gin.Icons.ActionEnum.tisk,
                caption: "jres:23900161", //RC 23900161 : Tisk knihy vypravené pošty
                run: function (ev, ctx) {
                    var act = GAction.createPrintAction({
                        name: "dlgTisk",
                        caption: "jres:23900162", //RC 23900162 : Generovani s dialogem
                        tooltip: "jres:23900162",
                        tema: "vyp_ptm_knvypp",
                        reportStarting: function (rep) {
                            rep.params.X0000 = content.SessionInfo.IxsSu!.toString();
                            rep.params.X0001 = Gordic.Templates.Formatters.datetime(content.IntervalOdDo.start!).format('yyyy.MM.DD');
                            var l_dateDo = Gordic.Utils.DateTime.addDays(Gordic.Utils.DateTime.parse(content.IntervalOdDo.end!), 1);
                            rep.params.X0002 = Gordic.Templates.Formatters.datetime(l_dateDo).format('yyyy.MM.DD');
                            rep.params.X0004 = content.LabelZnacka;
                        }
                    });
                    act.run();
                }
            });
            return action;
        }

        public static CreateActionTiskVykazu(content: GContentType<VypListBasePage>): GAction {
            var action = new GAction({
                name: Gordic.Vyp.Globals.Enums.ActionsName.TiskVykazu,
                icon: Gordic.Gin.Icons.ActionEnum.tisk,
                caption: "jres:23900164", //RC 23900164 : Tisk výkazů
                run: function (ev, ctx) {
                    var act = GAction.createPrintAction({
                        name: "dlgTisk",
                        caption: "jres:23900165", //RC 23900165 : Generovani s dialogem
                        tooltip: "jres:23900165",
                        tema: "vyp_ptm_denvyk",
                        reportStarting: function (rep) {
                            let l_settings = content.VypraveniSettings;
                            rep.params.X0000 = content.SessionInfo.IxsSu!.toString();
                            rep.params.X0001 = Gordic.Templates.Formatters.datetime(content.IntervalOdDo.start!).format('DD.MM.yyyy');
                            var l_dateDo = Gordic.Utils.DateTime.addDays(Gordic.Utils.DateTime.parse(content.IntervalOdDo.end!), 1);
                            rep.params.X0002 = Gordic.Templates.Formatters.datetime(l_dateDo).format('DD.MM.yyyy');
                            rep.params.X0003 = l_settings.cislo_podavatele ? l_settings.cislo_podavatele : "";
                            rep.params.X0004 = l_settings.uzivatel_vs ? l_settings.uzivatel_vs : "";
                            rep.params.X0005 = content.SessionInfo.IxsSu!.toString();
                            rep.params.X0006 = l_settings.psc ? l_settings.psc : "";
                            rep.params.X0007 = Gordic.Templates.Formatters.datetime(content.IntervalOdDo.end!).format('DD.MM.yyyy');
                        }
                    });
                    act.run();
                }
            });
            return action;
        }

        public static CreateActionTiskNakladu(content: GContentType<VypListBasePage>): GAction {
            var action = new GAction({
                name: Gordic.Vyp.Globals.Enums.ActionsName.TiskVykazu,
                icon: Gordic.Gin.Icons.ActionEnum.tisk,
                caption: "jres:23900166", //RC 23900166 : Tisk nákladu
                tooltip: "jres:23900166",
                run: function (ev, ctx) {
                    var act = GAction.createPrintAction({
                        name: "dlgTisk",
                        caption: "jres:23900165", //RC 23900165 : Generovani s dialogem
                        tooltip: "jres:23900165",
                        tema: "vyp_ptm_naklady",
                        reportStarting: function (rep) {

                            //e.Report.Parameters["X0001"] = tbOdDo.Od.ToString("yyyy.MM.dd");
                            //e.Report.Parameters["X0002"] = (UserProcess.LoginInfo.DatabaseType.ToString() == "Oracle") ?
                            //    tbOdDo.Do.Value.AddDays(1).ToString("yyyy.MM.dd") :
                            //    tbOdDo.Do.Value.ToString("yyyy.MM.dd");
                            rep.params.X0000 = content.SessionInfo.IxsSu!.toString();
                            rep.params.X0001 = Gordic.Templates.Formatters.datetime(content.IntervalOdDo.start!).format('DD.MM.yyyy');
                            var l_dateDo = Gordic.Utils.DateTime.addDays(Gordic.Utils.DateTime.parse(content.IntervalOdDo.end!), 1);
                            rep.params.X0002 = Gordic.Templates.Formatters.datetime(l_dateDo).format('DD.MM.yyyy');
                            rep.params.X0003 = Gordic.Templates.Formatters.datetime(content.IntervalOdDo.end!).format('DD.MM.yyyy');
                            rep.params.X0004 = content.SessionInfo.IxsSu!.toString();
                        }
                    });
                    act.run();
                }
            });
            return action;
        }

        public static CreateActionTiskVypravenychDokSpis(content: GContentType<VypListBasePage>): GAction {
            var action = new GAction({
                name: Gordic.Vyp.Globals.Enums.ActionsName.TiskVykazu,
                icon: Gordic.Gin.Icons.ActionEnum.tisk,
                caption: "jres:23900167", //RC 23900167 : Tisk přehledu vypravených dokumentů/spisů
                tooltip: "jres:23900167",
                run: function (ev, ctx) {
                    var act = GAction.createPrintAction({
                        name: "dlgTisk",
                        caption: "jres:23900165", //RC 23900165 : Generovani s dialogem
                        tooltip: "jres:23900165",
                        tema: "vyp_ptm_pre_vyp",
                        reportStarting: function (rep) {
                            rep.params.X0000 = content.SessionInfo.LogPorCislo!.toString();
                            rep.params.X0001 = content.ListParams.VyberTiskPA!.toString();
                            rep.params.X0002 = content.ListParams.IxsIsu ? content.ListParams.IxsIsu : "";
                            rep.params.X0003 = content.LabelZnacka;
                            rep.params.X0004 = content.ZpusobDorProp.toString();
                        }
                    });
                    act.run();
                }
            });
            return action;
        }

        public static CreateActionTiskEvidListPostovneho(content: GContentType<VypListBasePage>): GAction {
            var action = new GAction({
                name: Gordic.Vyp.Globals.Enums.ActionsName.TiskEvidListPostovneho,
                icon: Gordic.Gin.Icons.ActionEnum.tisk,
                caption: "jres:23900038", //RC 23900038 : Tisk - Evideční lístek poštovného
                tooltip: "jres:23900038",
                run: function (ev, ctx) {
                    var l_ptm = "vyp_ptm_elpost";
                    var act = GAction.createPrintAction({
                        name: "dlgTisk",
                        caption: "jres:23900037", //RC 23900037 : Generovani s dialogem
                        tooltip: "jres:23900037",
                        tema: l_ptm,
                        reportStarting: function (rep) {
                            rep.params.X0000 = content.SessionInfo.LogPorCislo!.toString();
                            rep.params.X0001 = content.ListParams.VyberTiskPA!.toString();
                        }
                    });
                    act.run();
                }
            });
            return action;
        }

        public static CreateActionFrankovaniOnLine(content: GContentType<VypListBasePage>, typ: Wfl.Interface.TypFrankovacihoStroje): GAction {
            var action = new GAction({
                name: Globals.Enums.ActionsName.FrankovaniOnline,
                icon: Icons.ActionEnum.frankovaniOnline,
                caption: "jres:23900105", //RC 23900105 : Frankovat - online
                tooltip: "jres:23900105",
                groupName: Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: function (ev, ctx) {
                     Wfl.ListAC.WflListBaseAC.OdznacVsechnyRadky(content);
                    VypListBasePage.NoveFrankovani(content);
                }
            });
            return action;
        }

        public static CreateActionFrankovaniOffLine(content: GContentType<VypListBasePage>, typ: Wfl.Interface.TypFrankovacihoStroje): GAction {
            var action = new GAction({
                name: Globals.Enums.ActionsName.FrankovaniOffline,
                icon: Icons.ActionEnum.frankovaniOffline,
                caption: "jres:23900150", //RC 23900150 : Import dat frankovacího stroje
                tooltip: "jres:23900150",
                groupName: Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: event => {
                    // this.signModule.signFile({ fileName: "test.pdf", filePath: "D:\\test.pdf", signWithTimeStamp: false }).then((signedConfig) => { ; }, (reason) => { ; })
                    VypListBasePage.addFileDoc(content);
                }
            });
            return action;
        }

        public static CreateActionPrevzitSFrankovanim(content: GContentType<VypListBasePage>): GAction {
            var action = new GAction({
                name: Globals.Enums.ActionsName.PrevzitSFrankovanim,
                icon: Gordic.Gin.Icons.ActionEnum.prevzit,
                caption: "jres:23900190", //RC 23900190 : Převzít s ofrankováním
                tooltip: "jres:23900191", //RC 23900191 : Převzít dle čtečky s ofrankováním
                run: function (ev, ctx) {
                    Wfl.ListAC.WflListBaseAC.OdznacVsechnyRadky(content);
                    Wfl.ListAC.WflListBaseAC.ZmenOznaceniVsechRadkuVTempTabulce(content, Gin.Interface.TypOznaceniRadkuSeznamu.Neurceno)
                        .done(function (ret)
                        {
                            VypListBasePage.CallDataMatrix(content, Gordic.Wfl.Interface.TypPouzitiDataMatrixCtecky.prevzetiSFrankovanim, true);
                        })
                        .fail(function (reason) { Wfl.ListAC.WflListBaseAC.ResolveFaildAkce(content, reason); });                 
                }
            });
            return action;
        }

        public static CreateActionImportDatEpaPosty(content: GContentType<VypListBasePage>): GAction {
            VypListBasePage.CreateGetFileFieldEPA(content);

            var action = new GAction({
                name: Globals.Enums.ActionsName.ImportDatEpaPosty,
                icon: Gordic.Gin.Icons.ActionEnum.importovat,
                caption: "jres:23900180", //RC 23900180 : Import dat podacího archu
                tooltip: "jres:23900180",
                run: event => {
                    VypListBasePage.addFileEPA(content);
                }
            });
            return action;
        }

        public static CreateGetFileField(content: GContentType<VypListBasePage>) {
            // filefield se nerenderuje, používá se pouze interně
            // kvuli importu file
            content._$fileField = $("<div>").gfilefield({
                fileUploaded: (event, data) => VypListBasePage._addFileFrankovani(content, data.fileInfo, data.customData),
            })
        }

        public static CreateGetFileFieldEPA(content: GContentType<VypListBasePage>) {
            // filefield se nerenderuje, používá se pouze interně
            // kvuli importu file
            content._$fileField = $("<div>").gfilefield({
                fileUploaded: (event, data) => VypListBasePage._addFileEPA(content, data.fileInfo, data.customData),
            })
        }

        public static _addFileFrankovani(content: GContentType<VypListBasePage>, fileInfo: Gordic.General.ApplicationInterface.GFileInfoDto, customData: any): void {
            let l_data: Gordic.Wfl.Interface.GSeznamZasilekDto[];
            if (content.VypraveniSettings.pouzivat_soubor_bez_pidu) {
                l_data = content.mainGrid.ggrid<Gordic.Wfl.Interface.GSeznamZasilekDto>("getSelection");
                if (!l_data || l_data.length == 0) {
                    content.dialogs.warning("jres:23900156"); //RC 23900156 : Nejsou označeny žádné řádky pro import dat.
                    return;
                }
            }
            else {
                l_data = content.mainGrid.ggrid<Gordic.Wfl.Interface.GSeznamZasilekDto>("getView").getDataRows(false);
            }

            content.call<Gordic.Wfl.Interface.GSeznamZasilekDto>("NactiFileFrankovani", { FileInfo: fileInfo, Data: l_data })
                .done(function (data)
                {
                    Wfl.ListAC.WflListBaseAC.UpdateData(content, data);
                    Wfl.ListAC.WflListBaseAC.ResolveResultData(content);
                    if (content.VypraveniSettings.tridit_dle_souboru)
                    {
                        //content.SortColumnName = "trid_vyp, k_v";
                        var l_view = content.mainGrid.ggrid("getView");
                        l_view.process({ mujSort: new Gordic.Data.SortProcessor("trid_vyp, k_v") });
                    }

                    Wfl.ListAC.WflListBaseAC.OznacRadkyDlePriznaku(content, Gordic.Gin.Interface.TypVysledkuOperace.Provedeno);
                    if (content.ResultType == Gin.Interface.TypVysledkuOperace.Provedeno) {
                        if (content.model.TypSeznamu == Gordic.Wfl.Interface.TypSeznamuZasilek.kPrevzetiDleID)
                        {
                            Wfl.ListAC.WflListBaseAC.SetEnableActionsByData(content);
                        }
                        else {
                            let l_text = content.Info;
                            l_text += Gin.Globals.Enums.UsedStrings.newLine + "jres:23900155";
                            content.dialogs.confirm("jres:23900014", l_text).on("yes", (ev, obj) => { //RC 23900014 : Dotaz
                                Wfl.ListAC.WflZasilkyListBaseAC.UlozData(content, content.actions.getActions()[0]);
                            });
                        }
                    } else Wfl.AC.WflBaseAC.ResolveInfo(content);
                })
                .always(function () {
                    content.endOperation();
                });
        }

        public static _addFileEPA(content: GContentType<VypListBasePage>, fileInfo: Gordic.General.ApplicationInterface.GFileInfoDto, customData: any): void {
            let l_data = content.mainGrid.ggrid<Gordic.Wfl.Interface.GSeznamZasilekDto>("getView").getDataRows(false);

            content.call<Gordic.Wfl.Interface.GSeznamZasilekDto>("NactiFileEPA", { FileInfo: fileInfo, Data: l_data })
                .done(function (data) {
                    Wfl.ListAC.WflListBaseAC.UpdateData(content, data);
                    Wfl.ListAC.WflListBaseAC.ResolveResultData(content);
                    Wfl.ListAC.WflListBaseAC.OznacRadkyDlePriznaku(content, Gordic.Gin.Interface.TypVysledkuOperace.Provedeno);
                    if (content.ResultType == Gin.Interface.TypVysledkuOperace.Provedeno) {
                        if (content.model.TypSeznamu == Gordic.Wfl.Interface.TypSeznamuZasilek.kPrevzetiDleID) {
                            Wfl.ListAC.WflListBaseAC.SetEnableActionsByData(content);
                        }
                        else {
                            let l_text = content.Info;
                            l_text += Gin.Globals.Enums.UsedStrings.newLine + "jres:23900155";
                            content.dialogs.confirm("jres:23900014", l_text).on("yes", (ev, obj) => { //RC 23900014 : Dotaz
                                Wfl.ListAC.WflZasilkyListBaseAC.UlozData(content, content.actions.getActions()[0]);
                            });
                        }
                    } else Wfl.AC.WflBaseAC.ResolveInfo(content);
                })
                .always(function () {
                    content.endOperation();
                });
        }

        public static addFileDoc(content: GContentType<VypListBasePage>) {
            content._$fileField.gfilefield("option", "customData", function () { return { isFavorite: true } });
            content._$fileField.gfilefield("instance").inputDiv.trigger("click")
        }

        public static addFileEPA(content: GContentType<VypListBasePage>) {
            content._$fileField.gfilefield("option", "customData", function () { return { isFavorite: true } });
            content._$fileField.gfilefield("instance").inputDiv.trigger("click")
        }

        public static CallDataMatrix(content: GContentType<VypListBasePage>, _typ: Gordic.Wfl.Interface.TypPouzitiDataMatrixCtecky, prvniVolani: boolean, warning?: string): void
        {
            content.DataMatrixDto = {};
            content.DataMatrixDto.KrokCislo = 1;
            content.DataMatrixDto.TypPouziti = _typ;
            content.DataMatrixDto.PracovatNadSeznamem = true;
            content.DataMatrixDto.PrvniVolani = prvniVolani;
            if (warning) content.DataMatrixDto.Warning = warning;
            switch (_typ) {
                case Wfl.Interface.TypPouzitiDataMatrixCtecky.frankovani:
                    content.DataMatrixDto.CistIPodaciCislo = content.VypraveniSettings.frankovani_podaci_cislo;
                    break;
                case Wfl.Interface.TypPouzitiDataMatrixCtecky.prevzetiSFrankovanim:
                    content.DataMatrixDto.CistIPodaciCislo = false;
                    break;
            }
            VypListBasePage.CallDataMatrixDialog(content);
        }

        public static NoveFrankovani(content: GContentType<VypListBasePage>): void
        {
            switch (content.VypraveniSettings.typ_frankovani)
            {
                case Wfl.Interface.TypFrankovacihoStroje.NeopostDataMatrixCtecka:
                    VypListBasePage.CallDataMatrix(content, Gordic.Wfl.Interface.TypPouzitiDataMatrixCtecky.frankovani, true)
                    break;
            }
        }

        public static CallDataMatrixDialog(content: GContentType<VypListBasePage>): void
        {
            Dialogs.DataMatrixCteckaCallDlg(content, { DataMatrixDto: content.DataMatrixDto }, Gordic.Global.Enums.ModOtevreni.showModalWindow)
                .done(function (retVal) {
                    if (retVal != null)
                    {
                        content.DataMatrixDto = retVal;
                        if (content.DataMatrixDto.id_dorucenky)
                        {
                            switch (content.DataMatrixDto.KrokCislo) {
                                case 1:
                                    VypListBasePage.ZpracujDataMatrix_krok_1(content);
                                    break;

                                case 2:
                                    VypListBasePage.ZpracujDataMatrix_krok_2(content);
                                    break;
                            }
                        }
                    }
                }
            );
        }

        public static ZpracujDataMatrix_krok_1(content: GContentType<VypListBasePage>): void {
            switch (content.DataMatrixDto.TypPouziti!)
            {
                case Gordic.Wfl.Interface.TypPouzitiDataMatrixCtecky.frankovani:
                    var l_pocet = Wfl.ListAC.WflListBaseAC.OznacRadkyDleIDAVratPocet(content, content.DataMatrixDto.id_dorucenky!, Wfl.Globals.Enums.FieldName.IdZasilky)
                    switch (l_pocet) {
                        case 1:
                            VypListBasePage.ZpracujDataMatrix(content);
                            break;

                        default:
                            let l_text = "";
                            if (l_pocet == 0) l_text = "jres:23900111" //RC 23900111 : Zásilka nebyla dohledána.
                            else l_text = "jres:23900109" //RC 23900109 : Identifikace zásilky není jednoznačná.
                            VypListBasePage.CallDataMatrix(content, content.DataMatrixDto.TypPouziti!, false, l_text);
                            break;
                    }
                    break;

                case Gordic.Wfl.Interface.TypPouzitiDataMatrixCtecky.prevzetiSFrankovanim:
                    VypListBasePage.ZpracujDataMatrix(content);
                    break;
            }
        }

        public static ZpracujDataMatrix_krok_2(content: GContentType<VypListBasePage>): void {
            switch (content.DataMatrixDto.TypPouziti!)
            {
                case Gordic.Wfl.Interface.TypPouzitiDataMatrixCtecky.frankovani:
                    let l_sxs = Wfl.ListAC.WflZasilkyListBaseAC.GetSXSRowByIDDorucenky(content, content.DataMatrixDto.id_dorucenky!)
                    var l_row = Wfl.ListAC.WflListBaseAC.GetRowByID(content, l_sxs);
                    var l_data = l_row.data;
                    if (content.DataMatrixDto.CistIPodaciCislo) l_data.pod_cislo = content.DataMatrixDto.pod_cislo;
                    l_data.poplatek = content.DataMatrixDto.poplatek;
                    l_data.vaha = content.DataMatrixDto.vaha;
                    Wfl.ListAC.WflListBaseAC.UpdateRowData(content, l_data);
                    content.NeulozenaData = true;
                    if (content.VypraveniSettings.frankovani_pretridit) {
                        if (content.DataMatrixDto.PrvniVolani) content.Poradi = 0;
                        Wfl.ListAC.WflListBaseAC.SetPoradiRadku(content, l_sxs, content.Poradi)
                        content.Poradi += 1;
                    }
                    VypListBasePage.CallDataMatrix(content, content.DataMatrixDto.TypPouziti!, false);
                    break;

                case Gordic.Wfl.Interface.TypPouzitiDataMatrixCtecky.prevzetiSFrankovanim:
                    VypListBasePage.PrevzitOfrankovanouZasilku(content);
                    VypListBasePage.CallDataMatrix(content, content.DataMatrixDto.TypPouziti!, false);
                    break;
            }
        }

        public static PrevzitOfrankovanouZasilku(content: GContentType<VypListBasePage>): void
        {
            Gin.Globals.ShowWaitLoadData(content);
            content.call<Gordic.Wfl.Interface.GSeznamZasilekDto[]>("PrevzitOfrankovanouZasilku", { Data: content.DataMatrixDto, model: content.model })
                .done(function (data) {
                    Gordic.Wfl.ListAC.WflListBaseAC.ResolveResultData(content, data, true, Gin.Interface.TypVysledkuOperace.Provedeno);
                    Gordic.Wfl.ListAC.WflListBaseAC.OznacRadkyDlePriznaku(content);                   
                })
                .always(function () { Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(content); });
        }

        public static ZpracujDataMatrix(content: GContentType<VypListBasePage>): void
        {
            switch (content.DataMatrixDto.TypPouziti!)
            {
                case Gordic.Wfl.Interface.TypPouzitiDataMatrixCtecky.frankovani:
                    let l_sxs = Wfl.ListAC.WflZasilkyListBaseAC.GetSXSRowByIDDorucenky(content, content.DataMatrixDto.id_dorucenky!)
                    if (l_sxs)
                    {
                        Gin.Globals.ShowFlash(content, "", Gordic.Gin.Globals.Enums.StateEnum.info, content.FlashPanelTimer, "Info");
                        content.DataMatrixDto.sxs = l_sxs;
                    }
                    else {
                        Gin.Globals.ShowFlash(content, "ERROR 23920060", Gordic.Gin.Globals.Enums.StateEnum.warning, content.FlashPanelTimer, "Info");
                    }
                    break;

                case Gordic.Wfl.Interface.TypPouzitiDataMatrixCtecky.prevzetiSFrankovanim:
                    //VypListBasePage.PrevzitOfrankovanouZasilku(content);
                    break;
            }

            content.DataMatrixDto.KrokCislo = 2;
            this.CallDataMatrixDialog(content);
        }
    }
}

